module.exports = __webpack_public_path__ + "img/tu1-4.df5681f4.png";